module.exports = __webpack_public_path__ + "img/img-sitio-anter_contacto.2a1004d5.svg";